"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const buildValidator_1 = __importDefault(require("./buildValidator"));
const valueIsTypeValidationError_1 = __importDefault(require("./valueIsTypeValidationError"));
const buildValueIsOneOf = (validators) => {
    const validationFunction = (value, options) => {
        let hasSuccessfulValidator = false;
        const optionErrors = [];
        for (let validatorIndex = 0; validatorIndex < validators.length; validatorIndex += 1) {
            const validator = validators[validatorIndex];
            try {
                hasSuccessfulValidator = validator(value, options);
                if (hasSuccessfulValidator) {
                    break;
                }
            }
            catch (error) {
                if (!(0, valueIsTypeValidationError_1.default)(error)) {
                    throw error;
                }
                optionErrors.push(error);
            }
        }
        if (!hasSuccessfulValidator && optionErrors.length > 0) {
            throw optionErrors.reduce((selectedError, optionError) => {
                if (optionError.path.length > selectedError.path.length) {
                    return optionError;
                }
                return selectedError;
            });
        }
        return hasSuccessfulValidator;
    };
    return (0, buildValidator_1.default)(validators.map((validator) => validator.typeName).join(' | '), validationFunction);
};
exports.default = buildValueIsOneOf;
